import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="a1now-footer">
      <div className="container">
        <div className="row j-c-center-s">
          <div className="col col-18 col-s-24">
            <nav className="a1now-footer__footernav a1now-footernav">
              <ul id="menu-footer-menu" className="a1now-footernav__ul">
                <li className="menu-item">
                  <NavLink to="/za-nas">За нас</NavLink>
                </li>
                <li className="menu-item">
                  <NavLink to="/pravila-za-polzvane">Правила за ползване</NavLink>
                </li>
                <li className="menu-item">
                  <a href="/politika-za-poveritelnost" target="_blank">
                    Политика за поверителност
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="col col-6 col-s-24">
            <div className="a1now-footer__copyright">© 2020 A1</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
